angular.module( 'acme.view.application.pos.create.pages.forms.generalAdmission', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.generalAdmission.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsGeneralAdmission = {
        name: 'application.pos.create.pages.forms.generalAdmission',
        url: '/generalAdmission',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsGeneralAdmissionController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/generalAdmission/generalAdmission.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(posCreatePagesFormsGeneralAdmission);
});
